import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { wa } from "@/lib/brand";

const MobileStickyCTA = () => (
  <div
    className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#004225] border-t border-[#D4AF37]/40 px-3 py-2.5 shadow-2xl"
    data-testid="mobile-sticky-cta"
  >
    <div className="flex items-center gap-2">
      <Link
        to="/request-quote"
        className="flex-1 rounded-full bg-[#D4AF37] text-[#002B18] px-4 py-2.5 text-[11px] font-semibold uppercase tracking-widest text-center"
        data-testid="mobile-quote-btn"
      >
        Request Quote
      </Link>
      <a
        href={wa()}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 rounded-full bg-[#25D366] text-white px-4 py-2.5 text-[11px] font-semibold"
        data-testid="mobile-whatsapp-btn"
      >
        <MessageCircle className="h-4 w-4" /> WhatsApp
      </a>
    </div>
  </div>
);

export default MobileStickyCTA;
